App.DishConfiguratorItemComponent = Em.Component.extend
  tagName: 'tr'
  classNames: ['config-line']

  item: null
  isDisabledFields: false

  checkFocus: (->
    item = @get('item')

    if item and item.focus
      @$('input[name="name"]').focus()
      # Удаляем focus чтобы свойство не ушло на сервер
      delete item.focus
  ).on('didInsertElement')

  actions:
    deleteLine: ->
      @sendAction('deleteLine', @get('item'))